import {ExperimentNames} from '@wix/wix-events-commons-statics'
import {useExperiments} from '@wix/yoshi-flow-editor'

export const useMobileFontOverrides = () => {
  const {experiments} = useExperiments()
  const stylesV2Enabled = experiments.enabled(ExperimentNames.StudioCompatibility)

  return {mobileFontOverridesEnabled: !stylesV2Enabled}
}
